import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import Section from 'components/ToolSignin/Section';

import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useAuth } from 'lib/providers/AuthProvider';
import { fetchTranslationFiles, LOCALE_PAGES } from 'lib/services/page';

const SignIn: React.FC = () => {
  const router = useRouter();
  const { isManager, manager, isInitialAuthLoading, isUnapprovedManager } =
    useAuth();
  const flow_state = manager?.flow_state;

  useEffect(() => {
    if (isManager) {
      if (flow_state === ONBOARDING_FLOW_STATE.COMPLETE)
        router.push(PAGE_ROUTES.DASHBOARD);
      else if (
        flow_state === ONBOARDING_FLOW_STATE.PRE_COMPLETE ||
        flow_state?.match(/post_/)
      )
        router.push(PAGE_ROUTES.SOCIETY_ONBOARDING);
      else router.push(PAGE_ROUTES.MANAGER_SIGN_UP);
    }
  }, [isManager, isUnapprovedManager, flow_state, router]);

  if (isInitialAuthLoading || isManager) return null;

  return (
    <>
      <Head>
        <title>Society Login | Huzzle</title>
        <meta
          name="description"
          content="Sign in to Huzzle as a Society manager."
        />
      </Head>
      <Section />
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.SIGN_IN],
      })),
    },
  };
}

export default SignIn;
